import { createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = { class: "highlight" }
const _hoisted_3 = /*#__PURE__*/_createVNode("button", {
  class: "highlight-copy btn",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Copy code"
}, " copy ", -1)
const _hoisted_4 = { class: "highlight-code" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("\n          ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("\n        ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("pre", {
          class: `language-${_ctx.lang}`,
          style: { height: _ctx.getHeightInPixesls }
        }, [
          _createVNode("code", {
            class: `language-${_ctx.lang}`
          }, [
            _hoisted_5,
            _renderSlot(_ctx.$slots, "default"),
            _hoisted_6
          ], 2)
        ], 6)
      ])
    ])
  ]))
}